export default __webpack_public_path__ + "static/adolescentes-c7d17db6194070bb94e9b64182a1ca13.png";